<div class="full-width py-3 px-4" fxLayout="column" fxLayoutAlign="start start">
  <div class="full-width mb-0" fxLayout="row" fxLayoutAlign="end center">
    <button class="button-close-top" mat-icon-button (click)="close(null)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="full-width" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="title-default">Create a Retailer</div>
  </div>

  <form class="full-width" [formGroup]="retailerForm" fxFlexOffset="20px">
    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Email</span>
        <mat-form-field appearance="outline" class="custom-text-field" style="width: 100%;">
          <input (focusout)="checkIfUserRelationshipExists()" [disabled]="!!(loader.loading$ | async)" formControlName="email"
                 matInput placeholder="Input text" type="email">
          <mat-error class="link-error">{{ getErrorMessage('email') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">First Name</span>
        <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
          <input matInput type="text" placeholder="Input text" formControlName="firstName">
          <mat-error class="link-error">{{getErrorMessage('firstName')}}</mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Last Name</span>
        <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
          <input matInput type="text" placeholder="Input text" formControlName="lastName">
          <mat-error class="link-error">{{getErrorMessage('lastName')}}</mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Company Name</span>
        <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%;">
          <input [disabled]="!!(loader.loading$ | async)" formControlName="companyName" matInput placeholder="Input text"
                 type="email">
          <mat-error class="link-error">{{getErrorMessage('companyName')}}</mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Website Url</span>
        <mat-form-field appearance="outline" class="custom-text-field" style="width: 100%;">
          <input formControlName="websiteUrl" matInput placeholder="www.example.com" type="text">
          <mat-error class="link-error">{{ getErrorMessage('websiteUrl') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Social Media Url</span>
        <mat-form-field appearance="outline" class="custom-text-field" style="width: 100%;">
          <input formControlName="socialMediaUrl" matInput placeholder="www.example.com/profile" type="text">
          <mat-error class="link-error">{{ getErrorMessage('socialMediaUrl') }}</mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Industry And Product Collection</span>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <app-industry-select
            [offeringUuid]="offering.offeringUuid"
            formControlName="industryTypes"
            placeholder="Industry And Product Collection"
            [required]="true">
          </app-industry-select>
          <mat-error class="link-error">{{getErrorMessage('industryTypes')}}</mat-error>
        </mat-form-field>
      </div>

    </div>
  </form>

  <mat-error class="body-1-error">{{this.errMessage}}</mat-error>

  <div class="full-width" fxFlexOffset="20px" fxLayout="row" fxLayoutAlign="space-between center">

    <button (click)="resetForm()" [disabled]="!!(loader.loading$ | async)" class="button-secondary" mat-flat-button>
      <mat-icon>restart_alt</mat-icon>
      <div class="button-text">Reset</div>
    </button>

    <button class="button-primary" mat-flat-button (click)="submitForm()" [disabled]="!!(loader.loading$ | async) || !canSubmit">
      <mat-icon>check</mat-icon>
      <div class="button-text">Submit</div>
    </button>
  </div>

</div>
